var settings = $(".elementor-element-" + wpdata.element_id).data("settings");

if (settings) {
  document.addEventListener("DOMContentLoaded", function () {
    var settings = $(".elementor-element-" + wpdata.element_id).data(
      "settings"
    );
    $("#elc__events-list__slider--" + wpdata.element_id).slick({
      slidesToShow: settings ? settings.slides_to_show : 3,
      infinite: true,
      dots: false,
      arrows: true,
      prevArrow:
        ".elementor-element-" + wpdata.element_id + " .slider-arrow-prev",
      nextArrow:
        ".elementor-element-" + wpdata.element_id + " .slider-arrow-next",
      responsive: [
        {
          breakpoint: 1216,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: settings ? settings.slides_to_show_tablet : 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            slidesToShow: settings ? settings.slides_to_show_tablet : 2,
            dots: false,
          },
        },
        {
          breakpoint: 580,
          settings: {
            arrows: false,
            slidesToShow: settings ? settings.slides_to_show_mobile : 1,
            dots: false,
          },
        },
      ],
    });
  });
}
